

require('xo-ui-components/src/directionality/directive');

define(['jquery', 'squid/index', 'text!./template.html', 'components/xo-ui-components/src/tooltip/directive', '../dob-input/directive', 'components/xo-models/src/checkout/index'], function ($, squid, template) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-national-id-input.directive', ['squid', 'xo-tooltip.directive', 'xo-dob-input.directive', 'xomodel.checkout']).directive('brIdValidations', function () {
        return {
            require: 'ngModel',

            link: function link(scope, element, attr, ctrl) {
                scope.cpfValidator = function cpfValidator(ngModelValue) {
                    var value = ngModelValue.replace(/[^0-9]/gi, '');
                    var len = value.length;

                    if (len !== 11) {
                        ctrl.$setValidity('nationalId', false);
                        return ngModelValue;
                    }

                    var x = value.match(/\b(\d)\1+\b/);

                    if (x) {
                        ctrl.$setValidity('nationalId', false);
                        return ngModelValue;
                    }

                    var v1 = 0;
                    var v2 = 0;
                    var dv1;
                    var dv2;
                    var i;
                    var j;

                    for (i = 0, j = 10; i < 9, j > 1; i++, j--) {
                        // eslint-disable-line no-sequences
                        v1 += j * +value[i];
                    }

                    v1 = v1 % 11;
                    dv1 = 11 - v1 < 10 ? 11 - v1 : 0;

                    for (i = 0, j = 11; i < 9, j > 2; i++, j--) {
                        // eslint-disable-line no-sequences
                        v2 += j * +value[i];
                    }

                    v2 += dv1 * 2;
                    v2 = v2 % 11;
                    dv2 = 11 - v2 < 10 ? 11 - v2 : 0;

                    scope.isValid = dv1 === parseInt(value[9], 10) && dv2 === parseInt(value[10], 10);

                    ctrl.$setValidity('nationalId', scope.isValid);

                    return ngModelValue;
                };

                ctrl.$parsers.push(scope.cpfValidator);
            }
        };
    }).directive('sgIdValidations', function () {
        return {
            require: 'ngModel',

            link: function link(scope, element, attr, ctrl) {
                scope.nricFinValidator = function nricFinValidator(ngModelValue) {
                    var idType = scope.$parent.nationalIdModel.nationalId.type;
                    if (idType === 'NATIONAL_ID') {
                        scope.isValid = false;

                        // Valid if first char is "S", "T", "F" or "G" and the rest 7 are digits.
                        if (ngModelValue.match(/^[S|T|G|F]\d{7}$/gi)) {
                            scope.isValid = true;
                        }
                    } else {
                        scope.isValid = true;
                    }
                    ctrl.$setValidity('nationalId', scope.isValid);
                    return ngModelValue;
                };
                ctrl.$parsers.push(scope.nricFinValidator);
            }
        };
    }).directive('ruIdValidations', function () {
        return {
            require: 'ngModel',

            link: function link(scope, element, attr, ctrl) {

                function validateSNILSChunk(sum, checksum) {
                    if (sum < 100 && sum === checksum) {
                        return true;
                    } else if ((sum === 100 || sum === 101) && checksum === 0) {
                        return true;
                    } else if (sum > 101) {
                        var remainder = sum % 101;
                        return validateSNILSChunk(remainder, checksum);
                    }

                    return false;
                }

                function validateSNILS(value) {
                    if (value.length === 11) {
                        if (Number(value) > 1001998) {
                            var snilsNumber = value.substring(0, 9);
                            var checksum = Number(value.substring(9));
                            var sum = 0;
                            var multiplier = 1;

                            for (var i = snilsNumber.length - 1; i >= 0; i--) {
                                sum = sum + Number(snilsNumber.charAt(i)) * multiplier;
                                multiplier++;
                            }

                            return validateSNILSChunk(sum, checksum);
                        }

                        return true;
                    }

                    return false;
                }

                function validateINNChecksum(value, factor, valueLength, match) {
                    var n;
                    var sumn = 0;
                    for (var i = 0; i < valueLength; i++) {
                        sumn = sumn + Number(value[i]) * Number(factor[i]);
                    }
                    n = sumn % 11;
                    n = n === 10 ? 0 : n;

                    if (n !== Number(match)) {
                        return false;
                    }

                    return true;
                }

                function validateINN(value) {
                    if (value.length === 12) {
                        var factor = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

                        if (!validateINNChecksum(value, factor, value.length - 2, value[10])) {
                            return false;
                        }

                        factor.unshift(3);

                        if (!validateINNChecksum(value, factor, value.length - 1, value[11])) {
                            return false;
                        }

                        return true;
                    }

                    return false;
                }

                function validateOMS(value) {
                    if (value.length >= 11 && value.length <= 16) {
                        return true;
                    }

                    return false;
                }

                scope.idValidator = function idValidator(ngModelValue) {
                    var value = ngModelValue.replace(/[^0-9]/gi, '');
                    var secondaryType = scope.nationalIdModel.secondaryIdType;

                    if (secondaryType === 'SNILS') {
                        scope.isValid = validateSNILS(value);
                    } else if (secondaryType === 'INN') {
                        scope.isValid = validateINN(value);
                    } else if (secondaryType === 'OMS') {
                        scope.isValid = validateOMS(value);
                    }

                    ctrl.$setValidity('secondaryId', scope.isValid);

                    return ngModelValue;
                };

                ctrl.$parsers.push(scope.idValidator);
            }
        };
    }).directive('xoNationalIdInput', function () {
        return {
            template: template,
            scope: {
                user: '=',
                country: '@'
            },

            link: function link(scope, element, attr) {
                var passportMask = '0000000000';

                element.on('keyup', function (event) {
                    if (scope.user.countryOfResidence === 'RU') {
                        $('#nationalId').mask(passportMask, {
                            'translation': {
                                0: { pattern: /[0-9]/ }
                            }
                        });
                    } else {
                        $('#nationalId').unmask(passportMask);
                    }
                });
            },

            controller: function controller($scope, $feature, $locale, $rootScope, $CheckoutCartModel, $NationalIdModel, $util) {

                $scope.nationalIdModel = $NationalIdModel.instance($rootScope.token);
                $scope.checkoutCart = $CheckoutCartModel.instance($rootScope.token);
                $scope.user = $scope.user || {};
                $scope.user.countryOfResidence = $scope.user.countryOfResidence || $scope.country;
                $scope.formattedValues = {};
                $scope.showNationalIdFields = false;

                if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.tax_id) {
                    $scope.nationalIdModel.nationalId.value = $scope.checkoutCart.payer.tax_id;
                }

                $scope.countryChanged = function () {
                    if ($scope.user.countryOfResidence === 'RU') {
                        $scope.showNationalIdFields = true;
                        $scope.minLengthNatId = 10;
                        $scope.maxLengthNatId = 10;
                    } else {
                        $scope.showNationalIdFields = false;
                        $scope.minLengthNatId = 6;
                        $scope.maxLengthNatId = 15;
                    }
                };

                $scope.cpfMasking = function (newValue) {
                    if (newValue) {
                        var unformatted = newValue.replace(/[^0-9]/gi, '');
                        var formatted = [['', unformatted.slice(0, 3)], ['.', unformatted.slice(3, 6)], ['.', unformatted.slice(6, 9)], ['-', unformatted.slice(9)]].map(function (x) {
                            return x[1] && x[0] + x[1] || '';
                        }).join('');

                        $scope.formattedValues.nationalId = formatted;
                        $scope.nationalIdModel.nationalId.value = unformatted;
                    } else {
                        $scope.nationalIdModel.nationalId.value = '';
                    }
                };

                $scope.secondaryIdFormatting = function () {
                    var $el = $('#idValue');

                    if ($scope.nationalIdModel.secondaryIdType === 'SNILS' && $el.length > 0) {
                        var unformatted = $el.val().replace(/[^0-9]/gi, '');
                        var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3, 6)], ['-', unformatted.slice(6, 9)], [' ', unformatted.slice(9)]].map(function (x) {
                            return x[1] && x[0] + x[1] || '';
                        }).join('');

                        $scope.nationalIdModel.secondaryIdValue = formatted;
                    }
                };

                $scope.secondaryIdChange = function () {
                    var currentSecondaryId = $scope.secondaryIds[$scope.nationalIdModel.secondaryIdType];

                    $scope.nationalIdModel.secondaryIdValue = '';
                    $scope.maxLength = currentSecondaryId.length;
                    $scope.minLength = currentSecondaryId.minlength ? currentSecondaryId.minlength : currentSecondaryId.length;

                    $scope.maskCharLength = currentSecondaryId.maskCharLength ? currentSecondaryId.maskCharLength : 0;
                };

                $scope.sgIdChange = function () {
                    $scope.nationalIdModel.nationalId.value = '';
                };

                function setLocalizedNatIDLabels() {
                    $scope.nationalIds = {
                        'PASSPORT': { name: 'PASSPORT_NUMBER', value: $locale.content.addTaxId.passport }
                    };

                    // National ID is not shown for South Korea
                    if ($locale.country !== 'KR') {
                        $scope.nationalIds.NATID = { name: 'NATIONAL_ID', value: $locale.content.addTaxId.natid };
                    }

                    // ID type change from “Driver’s License” to “TEMPORARY_NATIONAL_ID” for HK only,
                    // other countries show "Driver’s License" in th national ID drop down
                    if ($locale.country === 'HK' && $feature('driverLicenseToTempNationalID', false, $locale.country)) {
                        $scope.nationalIds.TNID = { name: 'TEMPORARY_NATIONAL_ID', value: $locale.content.addTaxId.tnid };
                    } else {
                        $scope.nationalIds.DL = { name: 'DRIVERS_LICENSE', value: $locale.content.addTaxId.dl };
                    }
                }

                function setLocalizedRUContent() {
                    $scope.countries = $locale.metadata.territory;
                    $scope.secondaryIds = {
                        'INN': { name: 'INN', value: $locale.content.addTaxId.INN, length: 12 },
                        'SNILS': { name: 'SNILS', value: $locale.content.addTaxId.SNILS, length: 14, maskCharLength: 3 },
                        'OMS': { name: 'OMS', value: $locale.content.addTaxId.OMS, length: 16, minlength: 11 }
                    };
                }

                if ($locale.country === 'BR') {
                    $scope.nationalIdModel.nationalId.type = 'TAX_ID';
                    $scope.nationalIdModel.nationalId.subType = 'CPF';

                    $scope.cpfMasking($scope.nationalIdModel.nationalId.value);
                } else if ($scope.country === 'RU') {
                    setLocalizedRUContent();
                    $scope.nationalIdModel.nationalId.type = 'PASSPORT';
                    $scope.nationalIdModel.nationalId.subType = '';
                    $scope.user.nativeName = $scope.user.nativeName || {};

                    if (!$scope.nationalIdModel.secondaryIdType) {
                        $scope.nationalIdModel.secondaryIdType = $scope.secondaryIds.INN.name;
                    }

                    $scope.secondaryIdChange();

                    $scope.countryChanged();
                } else if ($scope.country === 'KR') {
                    $scope.nationalIds = {
                        'PASSPORT': { name: 'PASSPORT_NUMBER', value: $locale.content.addTaxId.passport },
                        'DL': { name: 'DRIVERS_LICENSE', value: $locale.content.addTaxId.dl }
                    };
                    $scope.nationalIdModel.nationalId.type = 'PASSPORT_NUMBER';
                    $scope.nationalIdModel.nationalId.subType = '';
                } else {
                    // Default behaviour - set to 3pl countries
                    setLocalizedNatIDLabels();
                    $scope.nationalIdModel.nationalId.type = 'NATIONAL_ID';
                    $scope.nationalIdModel.nationalId.subType = '';
                }

                $scope.$on('contentChange', function () {
                    setLocalizedNatIDLabels();

                    if ($scope.country === 'RU') {
                        setLocalizedRUContent();
                    }
                });
            }
        };
    }).factory('$NationalIdModel', function ($Model) {

        return $Model.extend('NationalIdModel', {

            init: function init() {
                this._super.init.apply(this);
                this.nationalId = this.nationalId || {};
            },

            serialize: function serialize() {
                return this.nationalId;
            }
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/national-id-input/directive.js
// module id = ./components/xo-form-components/src/national-id-input/directive.js
// module chunks = 1